import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
// import { roles } from '../../common/config'

const RedirectPage = ({ viewer }) => {
  if (!viewer) return <Redirect to="/sign-in" />
  return <Redirect to="/results" />
}

RedirectPage.defaultProps = {
  viewer: null,
  children: null,
}

RedirectPage.propTypes = {
  viewer: React.PropTypes.object,
}

export default connect(state => ({
  viewer: state.users.viewer,
}))(RedirectPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Redirect.js